<script lang="ts">
	import type { ClassValue } from 'svelte/elements';

	type PictureSources = {
		type: string;
		srcset: string;
		sizes?: string;
		media?: string;
	};

	interface Props {
		src: string;
		sources: PictureSources[];
		alt: string;
		eager?: boolean;
		width?: string;
		height?: string;
		fetchPriority?: 'high' | 'low' | 'auto';
		class?: ClassValue;
	}

	const {
		src,
		alt,
		sources,
		width,
		height,
		fetchPriority,
		eager = false,
		class: classes = '',
	}: Props = $props();

	const loading = eager ? undefined : 'lazy';
	const decoding = eager ? 'sync' : 'async';
</script>

<picture>
	{#each sources as source, index (index)}
		<source {...source} />
	{/each}
	<img
		{src}
		{alt}
		{width}
		{height}
		{decoding}
		{loading}
		fetchpriority={fetchPriority}
		class={classes}
	/>
</picture>
